import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-midnight-navy py-12 border-t border-white/5" data-id="element-124">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-125">
        <Link to="/" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/2PmeGfc8FfeehVwkDn5EB7/ChatGPT_Image_Jul_7,_2026,_03_43_37_PM.png" alt="ROI Logo" className="h-24 w-auto object-contain" data-id="element-127" />
        </Link>
        <div className="text-white/40 text-sm" data-id="element-128">
          © 2026 ROI Restaurant Operations Intelligence. All rights reserved.
        </div>
        {/*
         <div className="flex gap-8 text-white/60 text-sm">
          <a href="#" className="hover:text-white transition-colors">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Terms of Service
          </a>
         </div>
         */}
      </div>
    </footer>;
}